import React, { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import api from "../../services/api.js";
import adicionar from "../../assets/icons8-mais-2-matemática-48.png";

import ItemAdm from "./ItensAdm";
import RealizadoPor from "./RealizadaPor";
import AutorizadoPor from "./AutorizadoPor";
import "react-toastify/dist/ReactToastify.css";
function Cadastro() {
  //  itens adm   COMEÇO
  const [marcadores, setMarcadores] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState();
  const optionList = marcadores.map((marcador, index) => ({
    value: marcador.manutencao,
    label: marcador.manutencao,
  }));

  const [marcadoresRealizadoPor, setMarcadoresRealizadoPor] = useState([]);
  const [selectedOptionsRealizadoPor, setSelectedOptionsRealizadoPor] = useState();
  const optionListRealizadoPor = marcadoresRealizadoPor.map((marcador, index) => ({
    value: marcador.descricao,
    label: marcador.descricao,
  }));

  const [marcadoresAutorizadoPor, setMarcadoresAutorizadoPor] = useState([]);
  const [selectedOptionsAutorizadoPor, setSelectedOptionsAutorizadoPor] = useState();
  const optionListAutorizadoPor = marcadoresAutorizadoPor.map((marcador, index) => ({
    value: marcador.autorizado,
    label: marcador.autorizado,
  }));
  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/AutorizadoPor", {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });
      setMarcadoresAutorizadoPor(data);
    }
    fetchData();
  }, []);
  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/ItemAdm", {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });
      setMarcadores(data);
    }
    fetchData();
  }, []);
  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get("/RealizadoPor", {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });
      setMarcadoresRealizadoPor(data);
    }
    fetchData();
  }, []);
  // Fim
  return (
    <>
      <div className="container ">
        <br></br>
        <div className="card card-top ">
          <div className="modal-header">
            <h5 className="modal-title text-dark" id="exampleModalToggleLabel">
              Manutenção Realizada
            </h5>
          </div>
          <div className="modal-body scroll-enfermeiro">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  Manutenção
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  Items
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-contact-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-contact"
                  type="button"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                >
                  Items - Administração
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-disabled-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-disabled"
                  type="button"
                  role="tab"
                  aria-controls="pills-disabled"
                  aria-selected="false"
                >
                  Realizada por - Cad
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="aut1"
                  data-bs-toggle="pill"
                  data-bs-target="#autorizado"
                  type="button"
                  role="tab"
                  aria-controls="pills-disabled"
                  aria-selected="false"
                >
                  Autorizado por - Cad
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              {/* manutenção */}
              <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                <form className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Veiculo</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tipo de manutenção</label>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" />
                      <label className="form-check-label">Preventiva</label>
                    </div>
                    <div className="form-check">
                      <input className="form-check-input" type="radio" />
                      <label className="form-check-label">Corretiva</label>
                    </div>
                  </div>
                  <div className="col-4">
                    <label className="form-label">Data da Última</label>
                    <input type="date" className="form-control" />
                  </div>
                  <div className="col-4">
                    <label className="form-label">Hodômetro na data (em Km)</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Intervalo (em Km)</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Data da manutenção</label>
                    <input type="date" className="form-control" i />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Hodômetro atual (em Km)</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Ordem de serviço (opcional)</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Realizada por (opcional)</label>
                    <Select options={optionListRealizadoPor} value={selectedOptionsRealizadoPor} isSearchable={true} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Autorizador por</label>
                    <Select options={optionListAutorizadoPor} value={selectedOptionsAutorizadoPor} isSearchable={true} />
                  </div>
                  <hr SIZE="5" WIDTH="1" ALIGN="center" />
                  <div className="col-md-4">
                    <div className="form-check">
                      <input className="form-check-input" type="radio" />
                      <label className="form-check-label">Agendar Proxima</label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Proxima Manutenção (em km) </label>
                    <input type="text" className="form-control" i />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Data limite</label>
                    <input type="date" className="form-control" />
                  </div>
                </form>
                <br></br>
                <div className="text-center">
                  <button type="button" className="btn btn-primary">
                    Cadastrar
                  </button>
                  <a href="javascript:history.back()" style={{ marginLeft: "7px" }}>
                    <button className="btn btn-outline-danger">Cancelar</button>
                  </a>
                </div>
              </div>
              {/* items */}
              <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                <h5 className="text-center">Peças e serviços</h5>
                <form className="row g-3 container">
                  <div className="col-md-4">
                    <label className="form-label">Item</label>
                    <Select options={optionList} value={selectedOptions} isSearchable={true} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Custo do item</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Observação</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="col-md-1">
                    <img src={adicionar} style={{ marginTop: "27px", marginLeft: "-15px" }} />
                  </div>
                </form>
                <br></br>
                <div className="container">
                  <div className="container text-center">
                    <div className="row ">
                      <div className="col rounded-top" style={{ background: "#304c7c", height: "55px" }}>
                        <h4 style={{ marginTop: "10px" }} className="text-white ">
                          Items da manutenção
                        </h4>
                      </div>
                    </div>
                  </div>
                  <table className="table table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Item</th>
                        <th scope="col">Obeservação</th>
                        <th scope="col">Custo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Mark</td>
                        <td>Otto</td>
                        <td>@mdo</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* items adm */}
              <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
                <ItemAdm />
              </div>
              {/* realizada Cad */}
              <div className="tab-pane fade" id="pills-disabled" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">
                <RealizadoPor />
              </div>
              {/* autorizado Cad */}
              <div className="tab-pane fade" id="autorizado" role="tabpanel" aria-labelledby="aut1" tabindex="0">
                {/* <h5 className="text-center">Administração</h5> */}
                <AutorizadoPor />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Cadastro;
